import { combineReducers } from 'redux';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import _pickBy from 'lodash/pickBy';
import createModal from './modules/createModal/reducer';

import {
  REQUEST_WORKFORCE_MEMBERS,
  RECEIVE_WORKFORCE_MEMBERS,
  RECEIVE_MORE_WORKFORCE_MEMBERS,
  REQUEST_MORE_WORKFORCE_MEMBERS,
  REPORT_WORKFORCE_MEMBERS_REQUEST_ERROR,
  SELECT_WORKFORCE_MEMBER,
  FILTER_WORKFORCE_MEMBER_DATA,
  SET_WORKFORCE_MEMBER_FILTER_QUERY,
  SELECT_ALL_WORKFORCE_MEMBERS,
  DESELECT_ALL_WORKFORCE_MEMBERS,
  RECEIVE_WORKFORCE_GROUP_DATA,
  SET_WORKFORCE_TOTAL_COUNT,
} from './actions';

const initialState = {
  pending: true,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  allGroupsData: {},
  lastKey: null,
  hasMore: false,
  loadingMore: false,
  totalCount: null,
};

const filterChunks = (chunks, filterHolder = '') => {
  let filteredChunks = chunks;
  // const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filterHolder !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filterHolder})`, 'gi');

      return (
        rgx.test(chunk.firstName) ||
        rgx.test(chunk.lastName) ||
        rgx.test(chunk.email)
      );
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const fields = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WORKFORCE_MEMBERS:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case REQUEST_MORE_WORKFORCE_MEMBERS:
      return {
        ...state,
        loadingMore: true,
      };

    case RECEIVE_WORKFORCE_MEMBERS: {
      const items = _keys(action.value);
      return {
        ...state,
        chunks: action.value,
        selected: [],
        filteredChunks: action.value,
        items,
        lastKey: action.lastKey != null ? action.lastKey : null,
        hasMore: Boolean(action.hasMore),
        pending: false,
        error: null,
        totalCount: !action.hasMore ? items.length : null,
      };
    }

    case RECEIVE_MORE_WORKFORCE_MEMBERS: {
      const newChunks = { ...state.chunks, ...action.value };
      const newItems = state.items.concat(_keys(action.value));
      return {
        ...state,
        chunks: newChunks,
        filteredChunks: state.filter
          ? filterChunks(newChunks, state.filter).filteredChunks
          : newChunks,
        items: state.filter
          ? filterChunks(newChunks, state.filter).items
          : newItems,
        lastKey: action.lastKey != null ? action.lastKey : state.lastKey,
        hasMore: Boolean(action.hasMore),
        pending: false,
        loadingMore: false,
        error: null,
        totalCount: !action.hasMore ? newItems.length : state.totalCount,
      };
    }

    case RECEIVE_WORKFORCE_GROUP_DATA:
      return {
        ...state,
        allGroupsData: action.value,
        pending: false,
      };

    case SET_WORKFORCE_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.count,
      };
    case SET_WORKFORCE_MEMBER_FILTER_QUERY:
      return {
        ...state,
        filter: action.payload,
      };

    case FILTER_WORKFORCE_MEMBER_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };

    case REPORT_WORKFORCE_MEMBERS_REQUEST_ERROR:
      return {
        ...state,
        pending: false,
        loadingMore: false,
        error: action.err,
      };

    case SELECT_WORKFORCE_MEMBER: {
      const prevState = state.filteredChunks[action.key].selected;
      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_WORKFORCE_MEMBERS: {
      const filteredChunks = _pick(state.chunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: !chunk.default,
      }));
      const selected = _union(
        state.selected,
        Object.keys(filteredChunks).filter(chunk => chunk !== 'default'),
      );

      return {
        ...state,
        filteredChunks: {
          ...state.chunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_WORKFORCE_MEMBERS:
      return {
        ...state,
        filteredChunks: _mapValues(state.chunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    default:
      return state;
  }
};

export default combineReducers({
  data: fields,
  createModal,
});
